import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./PetsyFirstVisitPopup.scss";
import { IPetsyFirstVisitPopupProps } from "./PetsyFirstVisitPopup.types";

export default function PetsyFirstVisitPopup(props: IPetsyFirstVisitPopupProps) {
  const [renderKey, setRenderKey] = React.useState(0);

  function modalClose() {
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  function submit(link: string) {
    if (link) {
      window.open(link, "_blank");
    }
    // modalClose();
  }

  return (
    <>
      <Modal
        className="flc_petsy-first-visit-popup"
        show={props.show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <div className="md-header-box">
            <div className="md-header-text">NEED HELP?</div>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          <div className="md-body-box">
            <img src="/images/icon-phone.svg" alt="" className="icon-phone" />
            <h3 className="md-body-heading">Need Help Understanding Pet Insurance?</h3>
            <p className="md-body-text">
              Speak with our friendly team who can explain how pet insurance works or assist you in
              getting a quote
            </p>
            <span className="md-body-text-2">Need help right now?</span>
            <p className="md-body-text">
              We’re available for phone support Monday to Saturday, 8:00am - 8:00pm AEST.{" "}
            </p>
            <span className="md-body-text-2">Call us</span>
            <div className="md-body-phone">
              <a href="tel:1300952790">1300 952 790</a>
            </div>
            <div className="md-body-phone-mobile">
              <img src="/images/ic-telephone.svg" alt="" />
              <a className="md-body-phone-mobile-link" href="tel:1300952790">1300 952 790</a>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="md-footer-box">
            <div className="md-footer-text">Or book a time that suits you</div>
            <a href="https://calendly.com/petsythepetpeople/new-meeting-1" className="btn-call-back">Book a call back</a>
            <div className="box-btn-continue">
              <button className="btn-continue" onClick={modalClose}>
                No thanks, I’ll continue on my own
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
